import { HttpClient } from '@angular/common/http';
import { FormClientSalesforce } from './form-client-salesforce';
import { WindowRefService } from '../../_shared/services/window-ref.service';
import { ConversionApiHelperService } from '../../../lib/form/form-conversion-api/form-conversion-api-helper.service';
import { FormSubmissionData } from '../../_shared/models/form/form-submission-data.model';

export class FormClientSalesforceMatchmaking extends FormClientSalesforce {
    constructor(
        httpClient: HttpClient,
        windowRef: WindowRefService,
        private _conversionApiHelper: ConversionApiHelperService
    ) {
        super(httpClient, windowRef);
    }

    private updateCommentsField(isVention: boolean): void {
        const name = this._conversionApiHelper?.getNameByIdentifier('comments');
        const value = this._conversionApiHelper?.getFieldValue('comments');

        if (name && value) {
            this._submission.data.fields[name] = `${value} isVention: ${isVention};`;
        }
    }

    private deserializeFormData(submissionData: FormSubmissionData): Record<string, unknown> {
        const deserializedData: Record<string, unknown> = {};

        for (const name in submissionData.fields) {
            const identifier = this._conversionApiHelper?.getIdentifierByName(name);

            if (identifier) {
                let value = submissionData.fields[name];
                value =
                    value && parseInt(value)
                        ? (this._conversionApiHelper?.getSelectValueByIdentifier(identifier) ??
                          value)
                        : value;

                deserializedData[identifier] = value;
            }
        }

        return deserializedData;
    }

    private waitForExternalValidation(): Promise<string> {
        return new Promise((resolve) => {
            const waitForVention = (event: MessageEvent) => {
                if (event.data.type === 'validation') {
                    window.removeEventListener('message', waitForVention);

                    const isValid = event.data.isValid;
                    this.updateCommentsField(isValid);

                    resolve(`Resolved by event listener: ${isValid}`);
                }
            };

            window.addEventListener('message', waitForVention);

            const formDataObject = this.deserializeFormData(this._submission.data);

            if (this.Window && this.Window.top && this.Window.self !== this.Window.top) {
                this.Window.top.postMessage(
                    {
                        type: 'needValidation',
                        data: formDataObject,
                    },
                    '*'
                );
            }

            setTimeout(() => resolve('Resolved by timeout'), 2000);
        });
    }

    override async submit() {
        this._conversionApiHelper.submissionData = this._submission.data;

        await this.waitForExternalValidation();

        super.submit();
    }
}
